const nonTitleCaseWords = Object.freeze([
  'and',
  'on',
  'a',
  'an',
  'the',
  'so',
  'or',
  'in',
  'for',
  'into',
  'to'
]);

export const toCustomTitleCase = function(str){
  if (!str){
    return '';
  }
  let words = str.split(' ');
  let customTitleCaseStr = getTitleCase(words[0]);
  for (let i = 1; i < words.length; i++){
    if (nonTitleCaseWords.includes(getLowerCase(words[i]))){
      customTitleCaseStr += ' ' + getLowerCase(words[i]);
    }
    else{
      customTitleCaseStr += ' ' + getTitleCase(words[i]);
    }
  }
  return customTitleCaseStr.trim();
}

function getTitleCase(str) {
  if (!str){
    return '';
  }

  // If a word is in UpperCase then it should be retained
  // Ex : HSR should not be converted into Hsr
  if (str.toUpperCase() === str)
    return str;

  return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
}

function getLowerCase(str) {
  if (!str){
    return '';
  }
  return str.toLowerCase();
}